
define("rv!templates/booking/hotel-new-search",[],function(){return { v:3,
  t:[ { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        type:"text/css",
        href:"/fe/css/responsive.css?v=1006" } },
    " ",
    { t:7,
      e:"div",
      a:{ "class":"hotel-search-container" },
      f:[ " ",
        { t:4,
          f:[ { t:7,
              e:"div",
              a:{ style:"text-align: center;" },
              f:[ { t:7,
                  e:"img",
                  a:{ id:"homeLoadIMG",
                    src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" } } ] } ],
          n:50,
          r:"loading" },
        { t:4,
          n:51,
          f:[ { t:7,
              e:"div",
              a:{ id:"map_canvas",
                style:"height: 400px; width: auto;" } } ],
          r:"loading" },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"hotel-search-form" },
          f:[ { t:4,
              n:53,
              f:[ { t:8,
                  r:"messenger" } ],
              r:"messenger" },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"hotel-inputs-container" },
              f:[ { t:7,
                  e:"div",
                  a:{ id:"dateInputs" },
                  f:[ { t:7,
                      e:"div",
                      a:{ id:"dateContainer" },
                      f:[ { t:7,
                          e:"label",
                          a:{ "for":"fromDate",
                            id:"fromDateLabel" },
                          f:[ "From:" ] },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"date",
                            "class":"search-changeable",
                            id:"fromDate",
                            value:[ { t:2,
                                r:"searchMeta.fromDate" } ] } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"dateContainer" },
                      f:[ { t:7,
                          e:"label",
                          a:{ "for":"toDate",
                            id:"toDateLabel" },
                          f:[ "To:" ] },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"date",
                            "class":"search-changeable",
                            id:"toDate",
                            value:[ { t:2,
                                r:"searchMeta.toDate" } ] } } ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"hotel-destination-inputs-container" },
                  f:[ { t:7,
                      e:"input",
                      a:{ type:"text",
                        "class":"search-changeable",
                        id:"destination",
                        placeholder:"Destination (e.g. Chicago, Il)",
                        value:[ { t:2,
                            r:"searchMeta.region.value" } ] } },
                    " ",
                    { t:7,
                      e:"select",
                      a:{ name:"destination-mileage",
                        "class":"search-changeable",
                        id:"mileageSelector",
                        value:[ { t:2,
                            r:"searchMeta.mileage" } ] },
                      f:[ { t:7,
                          e:"option",
                          a:{ value:"1" },
                          f:[ "1 mile" ] },
                        " ",
                        { t:7,
                          e:"option",
                          a:{ value:"10" },
                          f:[ "10 miles" ] },
                        " ",
                        { t:7,
                          e:"option",
                          a:{ value:"25",
                            selected:0 },
                          f:[ "25 miles" ] },
                        " ",
                        { t:7,
                          e:"option",
                          a:{ value:"50" },
                          f:[ "50 miles" ] },
                        " ",
                        { t:7,
                          e:"option",
                          a:{ value:"100" },
                          f:[ "100 miles" ] } ] } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"search-actions-container" },
              f:[ { t:7,
                  e:"div",
                  a:{ "class":"map-toggle-container" },
                  f:[ { t:7,
                      e:"label",
                      a:{ "for":"map-toggle" },
                      f:[ "Display Map:" ] },
                    " ",
                    { t:7,
                      e:"label",
                      a:{ "class":"toggle-switch" },
                      f:[ { t:7,
                          e:"input",
                          a:{ type:"checkbox",
                            id:"map-toggle" } },
                        " ",
                        { t:7,
                          e:"span",
                          a:{ "class":"slider" } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"map-info" },
                      f:[ { t:7,
                          e:"a",
                          a:{ href:"#map-information-modal",
                            "class":"infoLink map-info-link" },
                          f:[ { t:7,
                              e:"img",
                              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                                alt:"Map search information" } } ] } ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"hotel-guest-search-container" },
                  f:[ { t:7,
                      e:"button",
                      a:{ "class":"search-changeable",
                        id:"hotelGuestsButton" },
                      f:[ { t:2,
                          r:"searchMeta.adults" },
                        " ",
                        { t:2,
                          r:"adultTag" },
                        { t:4,
                          f:[ ", ",
                            { t:2,
                              r:"searchMeta.children" },
                            " ",
                            { t:2,
                              r:"childTag" } ],
                          n:50,
                          x:{ r:[ "searchMeta.children" ],
                            s:"_0>0" } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"hotel-guest-inputs-container hotel-search-triangle" },
                      f:[ { t:7,
                          e:"label",
                          a:{ "for":"adultNumber",
                            id:"adultNumberLabel" },
                          f:[ "Adults:" ] },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"number",
                            "class":"search-changeable",
                            id:"adultNumber",
                            min:"1",
                            max:"10",
                            value:[ { t:2,
                                r:"searchMeta.adults" } ] } },
                        " ",
                        { t:7,
                          e:"label",
                          a:{ "for":"childrenNumber",
                            id:"childrenNumberLabel" },
                          f:[ "Children:" ] },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"number",
                            "class":"search-changeable",
                            id:"childrenNumber",
                            min:"0",
                            max:"10",
                            value:[ { t:2,
                                r:"searchMeta.children" } ] } },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ id:"childAgeInput" },
                          f:[  ] } ] },
                    " ",
                    { t:7,
                      e:"button",
                      a:{ "class":"btn",
                        id:"hotelSearchButton" },
                      f:[ "Search" ] } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"map-information-modal",
                "class":"infoBox ps-infobox" },
              f:[ { t:7,
                  e:"p",
                  f:[ "The regions and hotels displayed are likely to have availability based on the From date entered. The properties may not have availability for your specific search." ] },
                " ",
                { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/#/faq/SearchMap" },
                      f:[ "Questions?" ] } ] } ] } ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"hotel-results" },
          f:[ { t:4,
              f:[ { t:4,
                  f:[ { t:7,
                      e:"div",
                      a:{ "class":"hotel-container" },
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"hotel-img-container" },
                          f:[ { t:7,
                              e:"img",
                              a:{ src:[ { t:2,
                                    r:".Image" } ] } } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ "class":"hotel-search-meta-container" },
                          f:[ { t:7,
                              e:"h3",
                              a:{ "class":"hotel-heading" },
                              f:[ { t:2,
                                  r:".Name" } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ "class":"hotel-description-container" },
                              f:[ { t:7,
                                  e:"p",
                                  f:[ { t:7,
                                      e:"span",
                                      a:{ "class":"meta-label" },
                                      f:[ "Address: " ] },
                                    { t:2,
                                      r:".DisplayAddress" } ] } ] },
                            " ",
                            { t:4,
                              n:53,
                              f:[ { t:8,
                                  r:"hotelRating" } ],
                              r:"./CategoryName" },
                            " ",
                            { t:4,
                              f:[ { t:7,
                                  e:"div",
                                  a:{ "class":"hotel-search-facilities" },
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"span",
                                          a:{ "class":"hb-exclusive-deal hotel-search-facility" },
                                          f:[ "Exclusive Room Deals!" ] } ],
                                      n:50,
                                      r:".ExclusiveDeal" },
                                    " ",
                                    { t:4,
                                      f:[ { t:7,
                                          e:"span",
                                          a:{ "class":"hotel-search-facility" },
                                          f:[ { t:2,
                                              r:".Description" },
                                            " ",
                                            { t:4,
                                              f:[ { t:2,
                                                  r:".DateFrom" } ],
                                              n:50,
                                              x:{ r:[ ".DateFrom" ],
                                                s:"_0!=\"\"" } },
                                            { t:4,
                                              n:51,
                                              f:[ { t:4,
                                                  n:50,
                                                  x:{ r:[ ".DateTo" ],
                                                    s:"_0!=\"\"" },
                                                  f:[ { t:2,
                                                      r:".DateTo" } ] },
                                                { t:4,
                                                  n:50,
                                                  x:{ r:[ ".DateTo",
                                                      ".Distance" ],
                                                    s:"(!(_0!=\"\"))&&(_1!=\"0\")" },
                                                  f:[ " ",
                                                    { t:2,
                                                      r:".Distance" } ] },
                                                { t:4,
                                                  n:50,
                                                  x:{ r:[ ".DateTo",
                                                      ".Distance",
                                                      ".TimeFrom" ],
                                                    s:"(!(_0!=\"\"))&&((!(_1!=\"0\"))&&(_2!=\"\"))" },
                                                  f:[ " ",
                                                    { t:2,
                                                      x:{ r:[ ".TimeFrom" ],
                                                        s:"_0.replace(/\\d+\\/\\d+\\/\\d{4}/,\"\")" } } ] },
                                                { t:4,
                                                  n:50,
                                                  x:{ r:[ ".DateTo",
                                                      ".Distance",
                                                      ".TimeFrom",
                                                      ".TimeTo" ],
                                                    s:"(!(_0!=\"\"))&&((!(_1!=\"0\"))&&((!(_2!=\"\"))&&(_3!=\"\")))" },
                                                  f:[ " ",
                                                    { t:2,
                                                      x:{ r:[ ".TimeTo" ],
                                                        s:"_0.replace(/\\d+\\/\\d+\\/\\d{4}/,\"\")" } } ] } ],
                                              x:{ r:[ ".DateFrom" ],
                                                s:"_0!=\"\"" } } ] } ],
                                      n:52,
                                      r:".Facilities" } ] } ],
                              n:50,
                              x:{ r:[ ".ProviderCode",
                                  "providers.Hotelbeds" ],
                                s:"_0==_1" } },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ "class":"price-deal-container" },
                              f:[ " ",
                                { t:7,
                                  e:"a",
                                  a:{ "class":"view-deal-button btn btn-large btn-primary",
                                    href:[ "/#/hotel-adestinn-details/",
                                      { t:2,
                                        r:".Code" },
                                      "/",
                                      { t:2,
                                        r:".BookingUrl" } ] },
                                  f:[ "View Property" ] } ] } ] } ] } ],
                  n:52,
                  r:"hotelResults" },
                " ",
                { t:7,
                  e:"div",
                  a:{ id:"minimum-price-modal",
                    "class":"infoBox ps-infobox" },
                  f:[ "This price represents a room rate that has been recently available at this property. It may not be available for the time of your stay." ] } ],
              n:50,
              x:{ r:[ "hotelResults.length" ],
                s:"_0>0" } },
            { t:4,
              n:51,
              f:[ { t:4,
                  n:50,
                  x:{ r:[ "hotelResults.length" ],
                    s:"_0==0" },
                  f:[ { t:7,
                      e:"p",
                      f:[ "There are no properties available at this time for these search parameters. Please change your search parameters and try again." ] } ] },
                { t:4,
                  n:50,
                  x:{ r:[ "hotelResults.length" ],
                    s:"!(_0==0)" },
                  f:[ " ",
                    { t:7,
                      e:"p",
                      f:[ "Please type in dates of travel." ] } ] } ],
              x:{ r:[ "hotelResults.length" ],
                s:"_0>0" } },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ style:"text-align: center;" },
                  f:[ { t:7,
                      e:"img",
                      a:{ id:"homeLoadIMG",
                        src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" } } ] } ],
              n:50,
              r:"loadingResults" } ] } ] } ] };});
